import type {
  CompanyType,
  Consortium,
  ContactSalutation,
  LifecycleStage,
  PreferredHotelType,
  SpecialOccasion,
} from '@travel-planner/shared/schemas/contact';
import { SUPPLIER_COMPANY_TYPE } from '@travel-planner/shared/schemas/contact';

export type {
  CompanyType,
  Consortium,
  Contact,
  ContactRole,
  ContactSalutation,
  CreateContactInput,
  FindContactsInput,
  LifecycleStage,
  PaginatedContacts,
  PreferredHotelType,
  SpecialOccasion,
  UpdateContactInput,
} from '@travel-planner/shared/schemas/contact';
// Controlled role list for a supplier's contacts, stored in `contact.title`
// (apps/crm/prd/crm-supplier-record.md §5).
export { contactRoleValues } from '@travel-planner/shared/schemas/contact';

// Object-literal lookup maps for dropdowns / form selects. The value
// side is constrained to the shared enum types so any drift from
// `contactSalutationValues` / `companyTypeValues` is a TS compile error.
export const contactSalutation = {
  MR: 'Mr.',
  MRS: 'Mrs.',
  MISS: 'Miss',
  DR: 'Dr.',
  PROF: 'Prof.',
} as const satisfies Record<string, ContactSalutation>;

// Only the types that can still be chosen. Agent, Lead and Prospect are
// retired (XT-892) — see `retiredCompanyTypeValues`.
export const companyType = {
  CUSTOMER: 'Customer',
  SUPPLIER: SUPPLIER_COMPANY_TYPE,
} as const satisfies Record<string, CompanyType>;

export const consortium = {
  VIRTUOSO: 'Virtuoso',
  SMART_FLYER: 'SmartFlyer',
  TRAVELLER_MADE: 'Traveller Made',
  SIGNATURE: 'Signature',
  ENSEMBLE: 'Ensemble',
  OTHER: 'Other',
} as const satisfies Record<string, Consortium>;

export const lifecycleStage = {
  LEAD: 'Lead',
  MARKETING_QUALIFIED: 'Marketing Qualified',
  SALES_QUALIFIED: 'Sales Qualified',
  OPPORTUNITY: 'Opportunity',
  CUSTOMER: 'Customer',
  OTHER: 'Other',
} as const satisfies Record<string, LifecycleStage>;

export const preferredHotelType = {
  BOUTIQUE: 'Boutique',
  FIVE_STAR: '5★',
  RESORT: 'Resort',
  VILLA: 'Villa',
  PALACE: 'Palace',
  OTHER: 'Other',
} as const satisfies Record<string, PreferredHotelType>;

export const specialOccasion = {
  HONEYMOON: 'Honeymoon',
  ANNIVERSARY: 'Anniversary',
  BIRTHDAY: 'Birthday',
  WEDDING: 'Wedding',
  BUSINESS: 'Business',
  OTHER: 'Other',
} as const satisfies Record<string, SpecialOccasion>;
